import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="256"
    height="256"
    fill="none"
    viewBox="0 0 256 256"
  >
    <g clipPath="url(#a)">
      <path
        stroke="#8803E9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M232 24H24v160h208V24ZM76 72l-24 32m24 32-24-32m120-32 24 32m-24 32 24-32M88 224a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm40 0a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm40 0a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h256v256H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
